"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.navReducer = void 0;
const navActions_1 = require("./navActions");
/**
 * Reusable utility function to check a single key with a boolean value update it if needed
 * @param contextKey
 * @param state
 * @param value
 * @returns
 */
const reduceBooleanField = (contextKey, state, value) => {
    if (typeof value !== "boolean") {
        return state;
    }
    const prev = state[contextKey];
    if (prev === value) {
        return state;
    }
    const newState = Object.assign({}, state);
    newState[contextKey] = value;
    return newState;
};
/**
 * Reusable utility function to check a single key with a string value update it if needed
 * @param contextKey
 * @param state
 * @param value
 * @returns
 */
const reduceStringField = (contextKey, state, value) => {
    if (typeof value !== "string") {
        return state;
    }
    const prev = state[contextKey];
    if (prev === value) {
        return state;
    }
    const newState = Object.assign({}, state);
    newState[contextKey] = value;
    return newState;
};
const navReducer = (state, action) => {
    const { type, value } = action;
    switch (type) {
        case navActions_1.ActionTypes.SET_MESSAGES: {
            if (!value || typeof value !== "object") {
                return state;
            }
            const prevMessagesStr = JSON.stringify(state.messages);
            const valueStr = JSON.stringify(value);
            if (prevMessagesStr === valueStr) {
                return state;
            }
            const newState = Object.assign({}, state);
            newState.messages = value;
            return newState;
        }
        case navActions_1.ActionTypes.SET_ACTIVE_MENU: {
            return reduceStringField("activeMenu", state, value);
        }
        case navActions_1.ActionTypes.SET_MOBILE_OPEN: {
            return reduceBooleanField("mobileMenuOpen", state, value);
        }
        case navActions_1.ActionTypes.SET_SEARCH_OPEN: {
            return reduceBooleanField("searchOpen", state, value);
        }
        case navActions_1.ActionTypes.SET_INNER_MOBILE_ACTIVE_MENU: {
            return reduceStringField("innerMobileActiveMenu", state, value);
        }
        case navActions_1.ActionTypes.SET_MOBILE_LOCALE_OPEN: {
            return reduceBooleanField("mobileLocaleOpen", state, value);
        }
        case navActions_1.ActionTypes.SET_MOBILE_SIGNIN_OPEN: {
            return reduceBooleanField("mobileSigninOpen", state, value);
        }
        default: {
            return state;
        }
    }
};
exports.navReducer = navReducer;
//# sourceMappingURL=navReducer.js.map